'use client';

import {
  CacheProvider as EmotionCacheProvider,
  css,
  Global,
  ThemeProvider as EmotionThemeProvider,
} from '@emotion/react';
import { PropsWithChildren } from 'react';
import { globalStyles, theme } from './theme';
import emotionCache from './cache';

export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <EmotionThemeProvider theme={theme}>
      <Global styles={css(globalStyles({ theme }))} />
      {children}
    </EmotionThemeProvider>
  );
}

export function CacheProvider({ children }: { children: React.ReactNode }) {
  return (
    <EmotionCacheProvider value={emotionCache}>{children}</EmotionCacheProvider>
  );
}
